import { useState, useEffect } from "react"
import { debounce } from "throttle-debounce"

export function useContainerSize() {
  const [containerWidth, setContainerWidth] = useState(1000)
  const [refEl, setRefEl] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    function resize() {
      if (!refEl) return
      setContainerWidth(refEl.offsetWidth)
      /* const style = window.getComputedStyle(refEl, null)
      const width = style.getPropertyValue("width").replace("px", "") * 1
      console.log("NEW WIDTH", width)
      setContainerWidth(width)*/
    }
    resize()
    const debouncedResize = debounce(200, resize)
    window.addEventListener("resize", debouncedResize)
    window.addEventListener("orientationchange", debouncedResize)
    return () => {
      window.removeEventListener("resize", debouncedResize)
      window.removeEventListener("orientationchange", debouncedResize)
    }
  }, [refEl])
  return [setRefEl, containerWidth, refEl] as const
}
